import { useEffect, useRef } from 'react';
import { Wizard } from 'react-use-wizard';
import { trackFormStarted } from '../../../shared/analytics';
import {
  generateBaselineFlow,
  generatePHQuestionsFlow,
  generateQuestionsStepForAllFlows,
  shouldReceivePHQuestionsFlow,
  getFormName
} from '../utils';
import { useReferralContext } from '../context';
import {
  LocationStep,
  EmailStep,
  PhoneStep,
  ServicesStep,
  VerificationStep,
  FullNameStep
} from './steps';

function ReferralForm() {
  const { referral, proInfo } = useReferralContext();
  const formWrapperRef = useRef<HTMLDivElement>(null);
  const hasFocused = useRef(false);

  function handleOnFocusIn() {
    if (!hasFocused.current) {
      trackFormStarted({ form_name: getFormName() });
      hasFocused.current = true;
    }
  }

  useEffect(() => {
    const formWrapperRefElement = formWrapperRef.current;
    if (formWrapperRefElement) {
      formWrapperRefElement.addEventListener('focusin', handleOnFocusIn);

      return () => {
        formWrapperRefElement.removeEventListener('focusin', handleOnFocusIn);
      };
    }
  }, []);

  return (
    <div ref={formWrapperRef}>
      <Wizard>
        <LocationStep />
        <ServicesStep />

        {shouldReceivePHQuestionsFlow(proInfo) &&
          generatePHQuestionsFlow(referral)}

        {!shouldReceivePHQuestionsFlow(proInfo) &&
          generateBaselineFlow(referral)}

        {generateQuestionsStepForAllFlows(referral)}

        <FullNameStep />
        <EmailStep />
        <PhoneStep />
        <VerificationStep />
      </Wizard>
    </div>
  );
}

export { ReferralForm };
